var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check-mark1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.41664547%",
    y1: "63.5286801%",
    x2: "99.9120757%",
    y2: "59.6320764%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8003F5",
    offset: "17.2799128%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D03F5",
    offset: "37.4835928%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D4863",
    offset: "55.5645872%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8003F5",
    offset: "79.7740473%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-129.2%",
    y: "-129.1%",
    width: "358.3%",
    height: "358.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.6666667,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.60742555e-13%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8334FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD88FF",
    offset: "75.237653%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8334FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.16173779e-13%",
    y1: "59.6320764%",
    x2: "100%",
    y2: "59.6320764%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8334FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD88FF",
    offset: "22.4541875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8334FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "example-5_mobile",
    transform: "translate(-57.000000, -261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-mark",
    transform: "translate(122.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    filter: "url(#filter-2)",
    cx: 42.5815789,
    cy: 56.3809321,
    rx: 42.5815789,
    ry: 42.6190679
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0630702,89.3223425 L42.5229605,88.4012472 C34.2729605,74.3325123 12.3496711,44.4764693 12.1282237,44.1766003 L11.8119737,43.7465948 L19.2811184,36.3585171 L42.924364,52.88246 C57.8107895,33.5481503 71.6987719,20.2684428 80.7578509,12.513617 C90.6677412,4.03060684 97.1184211,0.125307593 97.1835526,0.0878843232 L97.3302193,0 L110,0 L108.789759,1.07875592 C77.6643421,28.8265409 43.9276316,87.8017506 43.5916009,88.3942454 L43.0630702,89.3223425 Z",
    id: "Path",
    stroke: "url(#linearGradient-4)",
    strokeWidth: 2.75,
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bc7c6bd94b29209919d78d996792a2d2.svg";
export { ForwardRef as ReactComponent };